import { cva } from "class-variance-authority";
import { forwardRef } from "react";

const input = cva("input font-normal", {
  variants: {
    size: {
      sm: "px-2 py-1 text-sm input-sm",
      md: "px-4 py-2 text-base",
      lg: "px-6 py-3 text-lg",
    },
    variant: {
      standart: "",
      filled: "text-gray-700 bg-gray-200 border border-gray-300",
      outlined: "bg-transparent border-0 focus:outline-none !px-0",
    },
    checkbox: {
      true: "checkbox",
    },
    showRequired: {
      true: "text-[#8D4F61] border border-[#8D4F61]",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "standart",
  },
});

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: "sm" | "md" | "lg";
  variant?: "standart" | "filled" | "outlined";
  checkbox?: boolean;
  showRequired?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      size = "md",
      variant = "standart",
      className,
      checkbox,
      showRequired,
      ...props
    },
    ref,
  ) => {
    return (
      <input
        ref={ref}
        className={input({ size, variant, className, checkbox, showRequired })}
        {...props}
      />
    );
  },
);
